<template>
    <div class="dk-wizard-lead-form-modal-color-selection__car-image">
        <div
            class="dk-wizard-lead-form-modal-color-selection__car-image-wrapper tw-h-[156px] tw-overflow-hidden tw-max-w-[312px] tw-mx-auto max-lg:tw-mt-2"
        >
            <figure class="dk-wizard-lead-form-modal-color-selection__car-image-figure">
                <img class="tw-w-full" :src="image" :alt="fullName" height="auto">
            </figure>
        </div>
        <p
            class="dk-wizard-lead-form-modal-color-selection__disclaimer tw-mt-4 tw-text-center micro tw-text-base-subtle"
        >
            {{ $t('configuration-wizard.image-disclaimer') }}
        </p>
    </div>
</template>

<script>
export default {
    name: 'DkColorSelection',
    props: {
        image: {
            type: String,
            default: '',
        },
        fullName: {
            type: String,
            default: '',
        },
    },
};
</script>
